import { render, staticRenderFns } from "./CustomerInsight.vue?vue&type=template&id=41f29bec&scoped=true&"
import script from "./CustomerInsight.vue?vue&type=script&lang=js&"
export * from "./CustomerInsight.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41f29bec",
  null
  
)

export default component.exports